// @flow

import * as React from 'react';

import { ResponsiveImage } from '@ta/media.image';
import { Icon } from '@ta/styleguide.icon';
import { InteractionLogger } from '@ta/tracking.interactions';
import { Link } from '@ta/common.routing';
import classNames from '@ta/common.classnames';
import { localize, unescaped } from '@ta/common.i18n';
import { Abbreviate } from '@ta/common.text';

import LinkToTrip from './LinkToTrip';
import MatchingItemsMemberContent from './MatchingItemsMemberContent';
import styles from './MatchingTripShelfSection.less';

type Props = {
  /** The json trip object */
  trip: any,
  isSponsored?: boolean,
};

const tripLinkTo = (trip: any) => ({
  page: 'Trips',
  tripId: trip?.id,
  tripTitle: trip?.status === 'PUBLIC' ? trip?.title : undefined,
});

const getPhoto = (trip: any) => {
  const sources = trip?.photo?.photoSizes;
  const height = 150;
  const width = '100%';
  if (!sources) {
    return (
      <div className={styles.placeholder} style={{ width, height }}>
        <Icon name="suitcase" />
      </div>
    );
  }

  return <ResponsiveImage sources={sources} width={width} height={`${height}px`} />;
};

const MatchingTripShelfSection = ({ trip, isSponsored }: Props) => (
  <div className={`ui_card ${styles.trip_section}`}>
    <InteractionLogger>
      {logInteraction => (
        <React.Fragment>
          <div>
            <div className={styles.trip_photo_container}>
              <LinkToTrip trip={trip}>{getPhoto(trip)}</LinkToTrip>
            </div>
            <div className={styles.trip_details_container}>
              <LinkToTrip trip={trip}>
                <div className={styles.trip_title_container}>
                  <Abbreviate text={trip?.title} max={50} />
                </div>
              </LinkToTrip>
              {trip?.orderedLocations?.length > 2 && (
                <Link
                  to={tripLinkTo(trip)}
                  onClick={e => {
                    if (trip.registerClick) {
                      trip.registerClick();
                    }
                    logInteraction(e, 'feedClick');
                  }}
                  className={classNames('ui_link', styles.tagged_pois_container)}
                >
                  <span className={styles.tagged_pois}>
                    {unescaped(
                      localize('trips_home_featuring_count_v3', {
                        '0': styles.tagged_pois_featured,
                        '1': trip?.orderedLocations?.length || '',
                      }),
                    ) // Featuring: <span>{0, plural, one{# place} other{# places}}</span>
                    }
                  </span>
                </Link>
              )}
            </div>
          </div>
          <MatchingItemsMemberContent userProfile={trip.owner} isSponsored={isSponsored} />
        </React.Fragment>
      )}
    </InteractionLogger>
  </div>
);

export default MatchingTripShelfSection;
